import QuestionnairePreview from './QuestionnairePreview';

export default QuestionnairePreview;
